import { login, logout, newAccount, setupSession, quickPay, checkQuickPayAmount } from "api/accounts";
import { post as keepAlive } from "api/keepalive";
import { get as metadata } from "api/metadata";
import { change as changePassword, forgotPassword, reset as resetPassword, questions, securityQuestion } from "api/security";
/* Wrapper for all ajax activity for Authorization */
class AuthRepository {
    /**
     * Creates an authenticated session with the API
     *
     * @method login
     * @param {Object} credentials Information to send with request
     * @returns {axios.Promise}
     */
    login(credentials) {
        return login(credentials).then(({ data }) => data);
    }
    quickPay(token) {
        return quickPay(token).then(({ data }) => data);
    }
    checkQuickPayAmount(token, amount) {
        return checkQuickPayAmount(token, amount).then(({ data }) => data);
    }
    setupSession() {
        return setupSession().then(({ data }) => data);
    }
    /**
     * Ends the authenticated session with the API
     *
     * @method logout
     * @returns {*|AxiosPromise}
     */
    logout() {
        return logout();
    }
    /**
     * Creates user account in API info object
     *
     * @method create
     * @param {Object} info Information to send with request
     * @returns {axios.Promise}
     */
    create(info) {
        return newAccount(info).then(({ data }) => data);
    }
    /**
     * Extend the current users session on the API
     *
     * @method extendSession
     * @returns {axios.Promise}
     */
    extendSession() {
        return keepAlive();
    }
    /**
     * Retrieve the session length from the API
     *
     * @method fetchSessionLength
     * @returns {axios.Promise}
     */
    fetchSessionLength() {
        return metadata().then(({ data }) => data);
    }
    /**
     * Updates password
     *
     * @method updatePassword
     * @param {Object} info Information to send with request
     * @returns {axios.Promise}
     */
    updatePassword(info) {
        return changePassword(info).then(({ data }) => data);
    }
    /**
     * Forgot password
     *
     * @method forgotPassword
     * @param {Object} email Email address to send with request
     * @returns {axios.Promise}
     */
    forgotPassword(email) {
        return forgotPassword(email).then(({ data }) => data);
    }
    /**
     * Resets password (after forgot password)
     *
     * @method resetPassword
     * @param {Object} info Information to send with request
     * @returns {axios.Promise}
     */
    resetPassword(info) {
        return resetPassword(info).then(({ data }) => data);
    }
    /**
     * Retrieves security questions from API
     *
     * @method fetchSecurityQuestions
     * @returns {axios.Promise}
     */
    fetchSecurityQuestions() {
        return questions().then(({ data }) => data);
    }
    /**
     * Retrieves current security question from API
     *
     * @method fetchCurrentSecurityQuestion
     * @param {String} userId Id of user to get question for
     * @returns {axios.Promise}
     */
    fetchCurrentSecurityQuestion(userId, resetToken) {
        return securityQuestion({
            userId,
            resetToken
        }).then(({ data }) => data);
    }
}
export default new AuthRepository();



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/auth/AuthRepository.ts